<div *ngIf="entities">
  <mat-form-field style="width: 100%;" appearance="outline">
    <mat-label>Parent Entity</mat-label>
    <mat-select [value]="selectedEntityId" (selectionChange)="onSelect($event)">
      <mat-option *ngFor="let entity of entities" [value]="entity.id">{{entity.entity}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
